/** Koleksi Directus Pusat Notifikasi GEN-03 (docs/erd/current.md v010 `notification`; kolom tambahan = usulan D53). */
export const NOTIFICATION_COLLECTION = 'notification'

/** Endpoint custom GEN-03 (CUSTOM-NESTJS): daftar, jumlah belum dibaca, tandai dibaca. */
const BASE = '/api/v1/wms/notifications'
export const NOTIFICATION_ENDPOINT = {
  list: BASE,
  unreadCount: `${BASE}/unread-count`,
  read: `${BASE}/read`,
  readAll: `${BASE}/read-all`
} as const

/**
 * Role yang melihat tab "Semua Persona" di GEN-03 (DECISIONS D5: Admin, Supervisor, Kadiv; Operator, Produksi,
 * Purchasing dan Sales tidak). Salinan server: `NOTIFICATION_ALL_SCOPE_ROLES` di `@local-db/handlers/notification.handler.ts`
 * — kesamaan dijaga uji `notification.handler.test.ts`. Kandidat pengaturan admin M4 (Phase 7).
 */
export const NOTIFICATION_ALL_SCOPE_ROLES = [
  'admin_wh_rm',
  'admin_wh_sansugi',
  'admin_wh_fg',
  'wh_rm_supervisor',
  'supervisor_wh_fg',
  'kadiv_wh_rm',
  'kadiv_wh_fg'
] as const

export const canSeeAllNotifications = (roleCodes: readonly string[]) =>
  roleCodes.some(code => (NOTIFICATION_ALL_SCOPE_ROLES as readonly string[]).includes(code))

/** Interval polling lonceng topbar (ms). */
export const NOTIFICATION_POLL_MS = 20_000

/** Jumlah notifikasi di popover lonceng. */
export const NOTIFICATION_POPOVER_LIMIT = 8

/**
 * Jenis notifikasi (kontrak server ↔ FE). Salinan server: `@local-db/handlers/notification.shared.ts`
 * (`NOTIFICATION_TYPES`) — kesamaan dijaga uji `notification.handler.test.ts`. Untuk v7.50 backend NestJS cukup
 * mengisi `notification.type` dengan salah satu nilai ini.
 */
export const NOTIFICATION_TYPES = [
  'PR_SUBMITTED',
  'PR_PENDING_PURCHASING',
  'PR_APPROVED',
  'PR_REJECTED',
  'ARRIVAL_PALLET_CLOSED',
  'TOBACCO_RECEIPT_PENDING',
  'TOBACCO_RECEIPT_STATUS',
  'QC_ASSIGNED',
  'QC_DRAFT_SUBMITTED',
  'QC_RETURNED',
  'PUTAWAY_ASSIGNED',
  'REQUEST_SUBMITTED',
  'REQUEST_STATUS',
  'PICKING_ASSIGNED',
  'RO_PENDING_APPROVAL',
  'RO_STATUS',
  'RO_PICKUP_ASSIGNED',
  'TRANSFER_PENDING_APPROVAL',
  'TRANSFER_STATUS',
  'OPNAME_STARTED',
  'OPNAME_TASK_ASSIGNED',
  'DISCREPANCY_ESCALATED',
  'DISCREPANCY_DECIDED',
  'CLAIM_SORT_ASSIGNED',
  'CLAIM_AWAITING_APPROVAL',
  'CLAIM_AUTO_APPROVED',
  'ALM_REQUEST_CREATED',
  'ALM_PENDING_APPROVAL',
  'ALM_AUTO_APPROVED',
  'GAB_AUTO_APPROVED',
  'DESTRUCTION_PENDING_APPROVAL',
  'DESTRUCTION_ASSIGNED',
  'MOVE_TASK_ASSIGNED',
  'CAPTURE_ASSIGNED',
  'CAPTURE_STATUS',
  'SYSTEM_INFO'
] as const

export const NOTIFICATION_SEVERITIES = ['info', 'success', 'warning', 'critical'] as const

export const NOTIFICATION_QUERY_KEYS = {
  all: () => ['FETCH', 'LIST', 'WMS_NOTIFICATION'] as const,
  list: (params: unknown) => ['FETCH', 'LIST', 'WMS_NOTIFICATION', params] as const,
  popover: () => ['FETCH', 'LIST', 'WMS_NOTIFICATION', 'POPOVER'] as const,
  unreadCount: () => ['FETCH', 'DETAIL', 'WMS_NOTIFICATION_UNREAD'] as const,
  mutation: (name: string) => ['ACTION', name, 'WMS_NOTIFICATION'] as const
}

/** Segarkan daftar & badge setelah tandai dibaca. */
export const NOTIFICATION_INVALIDATE_KEYS = [
  ['FETCH', 'LIST', 'WMS_NOTIFICATION'],
  ['FETCH', 'DETAIL', 'WMS_NOTIFICATION_UNREAD']
] as const
